'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _immutable = require('immutable');

var _reduxDevtoolsExtension = require('redux-devtools-extension');

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// set up logger
var stateTransformer = function stateTransformer(state) {
	// transform to JS for logging
	if (_immutable.Iterable.isIterable(state)) {
		return state.toJS();
	}
	return state;
};

var logger = (0, _reduxLogger.createLogger)({
	stateTransformer: stateTransformer
});

// set up middleware
var middlewares = [_reduxThunk2.default];
if (process.env.NODE_ENV === 'development') {
	middlewares.push(logger);
}
var composeEnhancers = process.env.NODE_ENV !== 'production' ? _reduxDevtoolsExtension.composeWithDevTools : _redux.compose;
var configureStore = function configureStore() {
	var store = (0, _redux.createStore)(_reducers2.default, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

	if (module.hot) {
		// enable webpack HMR for reducers
		module.hot.accept('../reducers', function () {
			var nextRootReducer = require('../reducers/'); // eslint-disable-line global-require
			store.replaceReducer(nextRootReducer);
		});
	}

	return store;
};

var _default = configureStore;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(stateTransformer, 'stateTransformer', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(logger, 'logger', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(middlewares, 'middlewares', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(composeEnhancers, 'composeEnhancers', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(configureStore, 'configureStore', 'src/configureStore/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/configureStore/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/configureStore/index.js
// module id = eA2d
// module chunks = 62 63